"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retornaValorCondicionado = void 0;
/**
 * @param condicao boolean com a codição
 * @param valor1 retorno caso a condição seja verdadeira
 * @param valor2 retorno caso a condição seja falsa
 */
var retornaValorCondicionado = function (condicao, valor1, valor2) {
    if (condicao) {
        return valor1;
    }
    return valor2;
};
exports.retornaValorCondicionado = retornaValorCondicionado;
